import React, { useCallback, useEffect, useRef, useState } from "react";
import { PaperClipIcon, PhotoIcon } from "@heroicons/react/24/outline";
import { AXIOS_UPDATE, AXIOS_UPLOAD_DOCUMENT } from "../../server/api/crud";
import Swal from "sweetalert2";
import { getUser, getUserdetails } from "../../Localstorage/localstorage";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../../firebase/firebase";

const UploadBestandInput = ({ linkbackend, formData, editkey, setFormData, setLoading }) => {

  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const user = getUser();

  const onValueChangeFile = useCallback(
    async (event) => {
      setLoading(true);
      const item = event.target;
      const selectedFile = item.files[0];
      //setFile(selectedFile);
      try {
        // Create a reference to Firebase Storage with the user's name and file name
        const fileRef = ref(
          storage,
          `${user?.username}-${user?.id}/eetdagboek/${selectedFile.name}`
        );



        // Upload the file to Firebase Storage
        await uploadBytes(fileRef, selectedFile);

        // Get the file's URL after upload
        const fileURL = await getDownloadURL(fileRef);

        // Example: Call a function or endpoint to save the fileURL in your database
        //await setFormData(prev => ({...prev, url:fileURL}))
        let newObject = {...formData, url:fileURL}
        await handleUpload(newObject,selectedFile.name);
      } catch (error) {
        console.error("Upload failed:", error);
        Swal.fire("Upload failed", "", "error");
      } finally {
        setLoading(false);
      }
    },
    [user]
  );


  const handleButtonClick = () => {
    //if(linkbackend)
    fileInputRef.current.click();
  };

  const handleUpload = useCallback(async (newObject, name) => {

    if (!newObject?.url) {
      alert("Please choose an image first!");
      return;
    }

    try {

      let id = formData?.id;
  
      const response = await AXIOS_UPDATE(linkbackend, id, newObject);

      // Assuming your backend returns the updated user details, including the new avatar URL
      if (response.data.success) {
       // setLoading(false);
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: `Bestand ${name} is opgeladen`,
          showConfirmButton: false,
          timer: 2500,
        });
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `Bestand ${name}  is niet opgeladen`,
          showConfirmButton: false,
          timer: 2500,
        });
        // console.error('Upload failed:', response.data.message);
      }
    } catch (error) {
      Swal.fire({
        position: "top-end",
        icon: "error",
        title: `Fout bij het opladen van uw Bestand ${file?.name} `,
        showConfirmButton: false,
        timer: 2500,
      });

      console.error("Error uploading image:", error);
    }
  },[]);


  return (
    <div className="flex shrink-0 items-center gap-2.5">
      <input
        type="file"
        id="bestand"
        name="bestand"
        accept="image/*,pdf"
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={onValueChangeFile}
      />
      {formData?.url ? (
        <a
          href={formData?.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex"
          title="Bijlage openen"
        >
          <span className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-white/20 bg-emerald-700 text-white shadow-sm ring-1 ring-black/10 transition hover:bg-emerald-600 dark:border-white/15 dark:ring-white/10">
            <PaperClipIcon className="h-5 w-5" aria-hidden />
          </span>
        </a>
      ) : null}
      <button
        type="button"
        onClick={handleButtonClick}
        title="Afbeelding uploaden"
        aria-label="Afbeelding uploaden"
        className="flex h-[3.75rem] w-11 shrink-0 cursor-pointer flex-col items-center justify-center rounded-full border border-white/20 bg-sky-600 text-white shadow-sm ring-1 ring-black/10 transition hover:bg-sky-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-300 focus-visible:ring-offset-2 focus-visible:ring-offset-wa-panel dark:border-white/15 dark:ring-white/10"
      >
        <PhotoIcon className="h-6 w-6" strokeWidth={1.5} aria-hidden />
      </button>
    </div>
  );
};

export default UploadBestandInput;
